export const webSocketWorker = new Worker(
  new URL("./websocket.worker", import.meta.url),
  { type: "module" }
);

export const terminateWorkers = () => {
  webSocketWorker.terminate();
};
